import req from './api'

export const apiGetActs = (tenant) => req("get", `/admin/${tenant}/acts/`);
export const apiGetAct = (id, tenant) => req("get", `/admin/${tenant}/acts/${id}/`);
export const apiCreateAct = (tenant, data) => req("post", `/admin/${tenant}/acts/`, data);
export const apiEditAct = (id, tenant, data) => req("patch", `/admin/${tenant}/acts/${id}/`, data);

